/**
 * 任务驳回 assignmentRejectModule
 * 2019-05-13
 * Qian.qianchen
 */
'use strict';
angular.module("assignmentRejectModule", [])
    .controller("assignmentRejectCtrl", ["$scope", "$modalInstance", "$q", "$timeout", "assignmentId", "trsHttpService", "modalDialog", "$validation", function($scope, $modalInstance, $q, $timeout, assignmentId, trsHttpService, modalDialog, $validation) {
        initStatus();

        function initStatus() {
            $scope.status = {
                params: {
                    serviceid: "mlf_taskcommand",
                    methodname: "rejectTask",
                    TaskId: assignmentId,
                    Options: ""
                }
            }
            $scope.data = {
                reason: ""
            }
        }
        /**
         * [cancel description] 弹窗关闭
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        }
        /**
         * [confirm description] 确认驳回
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var defer = $q.defer();
            $scope.assignmentRejectForm.$pending = {};
            $validation.validate($scope.assignmentRejectForm)
                .success(function() {
                    let params = angular.copy($scope.status.params);
                    params.Options = $scope.data.reason;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                        modalDialog.alertType('任务驳回成功', '', 'success', false, function() {
                            $modalInstance.close();
                        });
                        defer.resolve();
                    });
                });
            return defer.promise;
        }
    }]);